import { render, staticRenderFns } from "./marketplaces.vue?vue&type=template&id=e3738ace&scoped=true&"
import script from "./marketplaces.vue?vue&type=script&lang=js&"
export * from "./marketplaces.vue?vue&type=script&lang=js&"
import style0 from "./marketplaces.vue?vue&type=style&index=0&id=e3738ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3738ace",
  null
  
)

export default component.exports